import {
  VuexModule,
  Module,
  Mutation,
  getModule,
  Action
} from "vuex-module-decorators";
import store from "@/general/store";

@Module({
  name: "modalState",
  namespaced: true,
  store,
  dynamic: true
})
class ModalStateModule extends VuexModule {
  closeModalState = false;
  modalName = "";
  updatedNewsData: any = {};

  @Mutation
  setCloseModalState(closeModalState: boolean) {
    this.closeModalState = closeModalState;
  }

  @Mutation
  setModalName(modalName: string) {
    this.modalName = modalName;
  }

  @Mutation
  setupdatedNewsData(data: any) {
    this.updatedNewsData = data;
  }

  @Action({ rawError: true })
  async switchCloseModalState() {
    const element: any = document.getElementById("app");
    await element.addEventListener("click", (e: any) => {
      const { closeModalState } = this;
      this.context.commit("setCloseModalState", !closeModalState);
    });
  }

  @Action
  switchHtmlElementScrollFixedStyle(shown: any) {
    const { body } = document;

    if (shown) {
      const scrollY = window.scrollY || 0;
      body.style.position = "fixed";
      body.style.top = `-${scrollY}px`;
      body.style.left = "0";
      body.style.width = "100%";
    } else if (body.style.position === "fixed") {
      const scrollY = (parseInt(body.style.top, 10) || 0) * -1;
      body.style.position = "";
      body.style.top = "";
      body.style.left = "";
      body.style.width = "";
      window.scrollTo(0, scrollY);
    }
  }

  @Action
  changeModal(name: string) {
    if (this.modalName === "" && name === "") {
      this.context.commit("setModalName", "");
    } else {
      this.context.commit("setModalName", name);

      const { body } = document;
      const shownModalOparationIndex = name === "" ? "hidden" : "shown";

      const shownModalOparation = {
        hidden() {
          const scrollTop = parseInt(body.style.top, 10);

          body.style.top = "";
          body.style.paddingRight = "";
          body.style.overflow = "";
          body.style.position = "";
          window.scrollTo(0, scrollTop * -1);
        },

        shown() {
          const scrollY = document.documentElement.scrollTop || body.scrollTop;
          const { clientWidth } = body;

          body.style.top = `-${scrollY}px`;
          body.style.overflow = "hidden";
          body.style.position = "fixed";

          const noScrollBarWidth = body.clientWidth;
          const diff = noScrollBarWidth - clientWidth;

          if (diff > 0) {
            body.style.paddingRight = `${diff}px`;
          }
        }
      };

      shownModalOparation[shownModalOparationIndex]();
    }
  }
}

export default getModule(ModalStateModule);
